// import * as React from "react";
import React, { useEffect } from 'react';
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import createStyles from "@material-ui/core/styles/createStyles";
import Amplify, { Auth } from "aws-amplify";
// @ts-ignore
import AWSAppSyncClient from "aws-appsync";
import { Rehydrated } from "aws-appsync-react";
import { ApolloProvider } from "react-apollo";
// import MomentUtils from '@date-io/moment';
// import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Snackbar, Button } from '@material-ui/core';

import withRoot from "../withRoot";
import { Dashboard } from "../components/baseLayout/Dashboard";
import awsmobile from "../aws-exports";
import * as serviceWorker from '../serviceWorker';
import AppSyncConfig from '../aws-exports';
import bucketConfig from '../../src/config/index';
import Routes from '../components/Routes';

Amplify.configure(awsmobile);

Amplify.configure({
	Auth: {
		identityPoolId: AppSyncConfig.aws_cognito_identity_pool_id,
		region: AppSyncConfig.aws_cognito_region,
		identityPoolRegion: AppSyncConfig.aws_cognito_region,
		userPoolId: AppSyncConfig.aws_user_pools_id,
		userPoolWebClientId: AppSyncConfig.aws_user_pools_web_client_id,
		mandatorySignIn: false,
	},
	Storage: {
		AWSS3: {
			bucket: bucketConfig.S3Bucket,
			region: bucketConfig.region,
		}
	}
});



const client = new AWSAppSyncClient({
  url: awsmobile.aws_appsync_graphqlEndpoint,
  region: awsmobile.aws_appsync_region,
  auth: {
    // @ts-ignore
    type: awsmobile.aws_appsync_authenticationType,
    apiKey: awsmobile.aws_appsync_apiKey
  },
  complexObjectsCredentials: () => Auth.currentCredentials()
});

const styles = (theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(20)
    }
  });

type State = {
  session: any;
};

class Index extends React.Component<WithStyles<typeof styles>, State> {
  state = { session: null };

  render() {
    return (
      // <MuiPickersUtilsProvider utils={MomentUtils}>
        <ApolloProvider client={client}>
          <Rehydrated>
            <Dashboard />
            {/* <Routes /> */}
          </Rehydrated>
        </ApolloProvider>
      // </MuiPickersUtilsProvider>
    );
  }
}

export default withRoot(withStyles(styles)(Index));


// const Index: React.FC = (props: any) =>  {
//   const [showReload, setShowReload] = React.useState(false);
//   const [waitingWorker, setWaitingWorker]: any = React.useState<ServiceWorker | null>(null);

//   const onSWUpdate = (registration: ServiceWorkerRegistration) => {
//     setShowReload(true);
//     setWaitingWorker(registration.waiting);
//   };

//   useEffect(() => {
//     serviceWorker.register({ onUpdate: onSWUpdate });
//   }, []);

//   const reloadPage = () => {
//     waitingWorker.postMessage({ type: 'SKIP_WAITING' });
//     setShowReload(false);
//     window.location.reload(true);
//   };

//   return (
//       <MuiPickersUtilsProvider utils={MomentUtils}>
//       {/* <BrowserRouter>
//       <Switch> */}
//       <ApolloProvider client={client}>
//           <Rehydrated>
//             <Dashboard />
//           </Rehydrated>
//         </ApolloProvider>
//       {/* </Switch>
//       </BrowserRouter> */}
//       <Snackbar
//         open={showReload}
//         message="A new version is available!"
//         onClick={reloadPage}
//         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//         action={
//           <Button
//             color="inherit"
//             size="small"
//             onClick={reloadPage}
//           >
//             Reload
//           </Button>
//         }
//       />
//       </MuiPickersUtilsProvider>
//     );
// }

// export default Index; // withRoot(withStyles(styles)(Index))

